
import React from 'react';
import { generateSitemapIndex } from '@/lib/schema/sitemap';

const SITE_URL = 'https://www.grandpal.co';

/**
 * Handles sitemap requests and returns the appropriate XML content
 */
export async function handleSitemapRequest(path: string): Promise<Response | null> {
  // Only handle sitemap paths
  if (!path.includes('/sitemap.xml') && !path.includes('/sitemaps/')) {
    return null;
  }

  console.log(`Sitemap middleware handling: ${path}`);
  
  try {
    // Use the Supabase Edge Function that handles sitemaps
    const supabaseUrl = 'https://vjthmlybhiphyoiipqjh.supabase.co/functions/v1';
    const sitemapPath = path === '/sitemap.xml' ? '/sitemap.xml' : path;
    
    try {
      const response = await fetch(`${supabaseUrl}/generate-sitemaps${sitemapPath}`, {
        headers: {
          'Content-Type': 'application/xml',
          'Cache-Control': 'public, max-age=3600'
        }
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      // Pass through the response from the edge function
      const content = await response.text();
      
      return new Response(content, {
        headers: {
          'Content-Type': 'application/xml',
          'Cache-Control': 'public, max-age=3600'
        }
      });
    } catch (fetchError) {
      console.error(`Error fetching sitemap from edge function:`, fetchError);
      
      // Fallback to local generation if the edge function fails
      let content: string;

      if (path === '/sitemap.xml' || path === '/sitemap.xml/') {
        content = generateSitemapIndex(SITE_URL);
      } else {
        // For specific sitemaps, redirect to the sitemap index as fallback
        return new Response(null, {
          status: 302,
          headers: {
            'Location': '/sitemap.xml',
            'Cache-Control': 'no-cache'
          }
        });
      }

      return new Response(content, {
        headers: {
          'Content-Type': 'application/xml',
          'Cache-Control': 'public, max-age=3600'
        }
      });
    }
  } catch (error: any) {
    console.error('Error in sitemap middleware:', error);
    return new Response(`<?xml version="1.0" encoding="UTF-8"?><error>${error.message}</error>`, {
      status: 500,
      headers: {
        'Content-Type': 'application/xml'
      }
    });
  }
}
